module.exports = __webpack_public_path__ + "img/long-arrow-alt-up.81ac6fa9.svg";